import { toast } from 'react-toastify';
import { acClose } from 'ac-icon';
import React from 'react';
import { ButtonIcon } from '../button/ButtonIcon';
function createToast(content, options, onClick) {
    toast(React.createElement("div", { onClick: onClick }, content), Object.assign({ autoClose: (options === null || options === void 0 ? void 0 : options.autoClose) ? options === null || options === void 0 ? void 0 : options.autoClose : 3000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, position: 'bottom-right', className: 'ac-toast', progressClassName: 'ac-toast-progress', closeButton: (props) => {
            return (React.createElement(ButtonIcon, { iconPath: acClose, color: 'primitiveNavyBlue', className: 'justify-content-start', onClick: props.closeToast, title: 'Закрыть' }));
        } }, (options || {})));
}
function createSuccessToast(content, options, onClick) {
    return createToast(content, Object.assign(Object.assign({}, options), { type: 'success' }), onClick);
}
export { createToast, createSuccessToast };
//# sourceMappingURL=toast.js.map